/* eslint-disable no-new */
export default {
    /**
     * @override
     */
    setCountries({ commit }, countries) {
        new Promise(resolve => {
            commit('SET_COUNTRIES', countries);
            resolve();
        });
    }
};
